//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["action"],"PerformSimulation",{},1,0],[["nLogicalTypes","logicalTypeNames","logicalTypeBitmaps"],"GetLogicalTypes",{},0,0],[["numAttributeNames","attributeNames"],"GetLogicalAttributeNames",{},0,0],[["logicalObject","attributeNames"],"GetLogicalAttributeValues",{R_:{attributeValues:""}},2,0],[["logicalObject","numExportableLogicalObjects"],"GetExportableLogicalObjects",{R_:{exportableLogicalObjects:"Mechatronics.LogicObject[]"}},1,0]],[]];
SPLM.Mechatronics.MechatronicsSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Mechatronics.MechatronicsSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.MechatronicsSession.SimulationAction = Object.freeze({
    "Start" : "Start", "Restart" : "Restart", "Pause" : "Pause", "Resume" : "Resume", "Stop" : "Stop"});

export default SPLM;